
//@ts-nocheck
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import pinia from './store'
import service from "@/http/axios.js";

const app = createApp(App)
app.config.globalProperties.$axios = service;


// 挂载到 window
window['$vue'] = app

app.use(pinia)
app.use(router)

// 挂载到页面
app.mount('#app', true)
